"use strict";
var polyline = {},
  EARTH_RADIUS = 6371;
function extendTimeAwarePolyline(t, e, n) {
  var r = 0,
    o = 0,
    a = 0;
  if (
    (null == t && (t = ""),
    null != n && ((r = getLat(n)), (o = getLng(n)), (a = getTimeStamp(n))),
    e.length < 1)
  )
    return t;
  for (var i = 0; i < e.length; i++) {
    for (
      var l = e[i],
        s = getLat(l),
        g = getLng(l),
        u = getTimeStamp(l),
        h = [s - r, g - o, u - a],
        f = 0;
      f < h.length;
      f++
    ) {
      var p = h[f];
      for (
        p = p < 0 ? notOperator(lshiftOperator(p, 1)) : lshiftOperator(p, 1);
        p >= 32;

      )
        (t += String.fromCharCode(63 + (32 | (31 & p)))),
          (p = rshiftOperator(p, 5));
      t += String.fromCharCode(p + 63);
    }
    (r = s), (o = g), (a = u);
  }
  return t;
}
function getDecodedDimensionFromPolyline(t, e) {
  for (var n = 1, r = 0; ; ) {
    var o = t[e].charCodeAt(0) - 63 - 1;
    if ((e++, (n += lshiftOperator(o, r)), (r += 5), o < 31)) break;
  }
  return n % 2 != 0
    ? [e, rshiftOperator(notOperator(n), 1)]
    : [e, rshiftOperator(n, 1)];
}
function getLocationsTillTimeStamp(t, e) {
  var n = t,
    r = 0,
    o = [],
    a = [],
    i = 0;
  if (0 == n.length) return { locations: [], bearing: i };
  for (var l = e, s = n[0][2]; l <= s; )
    return { locations: [[n[0][0], n[0][1]]], bearing: i };
  for (r = 0; r < n.length; r++) {
    if ((o.push(n[r]), 2 == o.length)) {
      l = e;
      i = updateBearing(i, o);
      s = o[0][2];
      var g = o[1][2];
      if (l > s && l <= g) {
        var u = getLocationInPair(o, l);
        return a.push(u), { locations: a, bearing: i };
      }
      o.shift();
    }
    a.push([o[0][0], o[0][1]]);
  }
  return { locations: a, bearing: i };
}
function isDifferentSegment(t, e) {
  return getDistance(e, t) > 500;
}
function getPolylineSegments(t, e) {
  var n = [],
    r = [],
    o = 0;
  if (0 == t.length) return [];
  var a = t[0];
  for (o = 0; o < t.length; o++) {
    if (!(t[o][2] <= e)) {
      isDifferentSegment(t[o], a) || r.push(t[o]);
      break;
    }
    isDifferentSegment(t[o], a) && r.length > 0
      ? (n.push({ segment: r, style: "solid" }),
        (r = [r[r.length - 1], t[o]]),
        n.push({ segment: r, style: "dotted" }),
        (r = [t[o]]))
      : r.push(t[o]),
      (a = t[o]);
  }
  return n.push({ segment: r, style: "solid" }), n;
}
function updateBearing(t, e) {
  var n = computeHeading([e[0][0], e[0][1]], [e[1][0], e[1][1]]);
  return 0 != n ? Math.round(100 * n) / 100 : t;
}
function getLocationInPair(t, e) {
  var n = t[0][0],
    r = t[0][1],
    o = t[1][0],
    a = t[1][1],
    i = new Date(t[0][2]),
    l = new Date(t[1][2]),
    s = (i - new Date(e)) / (i - l);
  return [n * (1 - s) + o * s, r * (1 - s) + a * s];
}
function getNextLatLng(t, e) {
  var n = t.length;
  if (n > 0) {
    for (var r = 0; r < n - 1; r++) {
      if (e < t[r][2]) return [t[r][0], t[r][1]];
    }
    return [t[n - 1][0], t[n - 1][1]];
  }
}
function getDistance(t, e) {
  var n = toRadian(t[1]),
    r = toRadian(t[0]),
    o = toRadian(e[1]),
    a = toRadian(e[0]),
    i = a - r,
    l = o - n,
    s =
      Math.pow(Math.sin(i / 2), 2) +
      Math.cos(r) * Math.cos(a) * Math.pow(Math.sin(l / 2), 2);
  return 2 * Math.asin(Math.sqrt(s)) * EARTH_RADIUS * 1e3;
}
function toRadian(t) {
  return (t * Math.PI) / 180;
}
function computeHeading(t, e) {
  var n = toRadian(t[0]),
    r = toRadian(e[0]),
    o = toRadian(t[1]),
    a = toRadian(e[1]);
  return (
    (180 *
      Math.atan2(
        Math.sin(a - o) * Math.cos(r),
        Math.cos(n) * Math.sin(r) - Math.sin(n) * Math.cos(r) * Math.cos(a - o)
      )) /
    Math.PI
  );
}
function areEqualLatlngs(t, e) {
  return t[0] == e[0] && t[1] == e[1];
}
function removeTimeStamps(t) {
  for (var e = [], n = 0; n < t.length; n++) e.push([t[n][0], t[n][1]]);
  return e;
}
function getCoordinate(t) {
  return +(1e-5 * t).toFixed(5);
}
function getIsoTime(t) {
  return new Date(1e3 * t).toISOString();
}
function getGpxLog(t, e, n) {
  return [getCoordinate(t), getCoordinate(e), getIsoTime(n)];
}
function getLat(t) {
  return Math.round(1e5 * t[0]);
}
function getLng(t) {
  return Math.round(1e5 * t[1]);
}
function getTimeStamp(t) {
  return +new Date(t[2]) / 1e3;
}
function lshiftOperator(t, e) {
  return t * Math.pow(2, e);
}
function rshiftOperator(t, e) {
  return Math.floor(t / Math.pow(2, e));
}
function notOperator(t) {
  return ~t;
}
(polyline.encodeTimeAwarePolyline = function (t) {
  return extendTimeAwarePolyline("", t, null);
}),
  (polyline.decodeTimeAwarePolyline = function (t) {
    for (var e = [], n = 0, r = 0, o = 0, a = 0, i = t.length; n < i; ) {
      var l = getDecodedDimensionFromPolyline(t, n),
        s = getDecodedDimensionFromPolyline(t, (n = l[0])),
        g = getDecodedDimensionFromPolyline(t, (n = s[0]));
      (n = g[0]),
        (r += l[1]),
        (o += s[1]),
        (a += g[1]),
        e.push(getGpxLog(r, o, a));
    }
    return e;
  }),
  (polyline.getLocationsAtTimestamps = function (t, e) {
    var n = 0,
      r = [];
    for (n = 0; n < e.length; n++) {
      var o = getLocationsTillTimeStamp(t, e[n]).locations;
      o.length > 0 ? r.push(o[o.length - 1]) : r.push([]);
    }
    return r;
  }),
  (polyline.getLocationsElapsedByTimestamp = function (t, e) {
    var n = getLocationsTillTimeStamp(t, e);
    return { path: n.locations, bearing: n.bearing };
  }),
  (polyline.getPolylineSegments = function (t) {
    for (
      var e = getPolylineSegments(t, t[t.length - 1][2]), n = [], r = 0;
      r < e.length;
      r++
    )
      n.push({ path: removeTimeStamps(e[r].segment), style: e[r].style });
    return n;
  }),
  (polyline.getPolylineSegmentsForLocationsElapsed = function (t, e) {
    for (var n = getPolylineSegments(t, e), r = [], o = 0; o < n.length; o++) {
      var a = polyline.getLocationsElapsedByTimestamp(n[o].segment, e);
      a.path.length > 0 &&
        r.push({ path: a.path, bearing: a.bearing, style: n[o].style });
    }
    return r;
  });
